const accountVerifiedStyles = (theme) => {
  return {
    inputStyles: {
      height: 25,
      minWidth: 140,
      // marginRight: theme.spacing(1),
      // marginLeft: theme.spacing(1),
      marginTop: theme.spacing(2.5),
      marginBottom: theme.spacing(5),
      flex: 1,
      // paddingLeft: 5,
      '& .MuiFormHelperText-contained': {
        marginLeft: 0,
        fontSize: 10,
      },
      '& .MuiFormHelperText-root': {
        marginTop: 0,
        fontSize: 10,
      },
      '& .MuiInputLabel-outlined': {
        // fontSize: 10,
        paddingLeft: 5,
        paddingRight: 0,
      },
      // '& .MuiOutlinedInput-notchedOutline': {
      //   borderColor: '#000000',
      // },
      '& .MuiOutlinedInput-root.Mui-error .MuiOutlinedInput-notchedOutline': {
        borderColor: '#000000',
      },
    },
  };
};

export default accountVerifiedStyles;
